// extracted by mini-css-extract-plugin
export default {"projectsFeatures":"projectsFeatures_projectsFeatures__A+EFT","wrapper":"projectsFeatures_wrapper__rRWBI"};